export const Estrategia = () => {
  return <div>Estrategia</div>
}
